import { render, staticRenderFns } from "./ListRecommend.vue?vue&type=template&id=096c4c6a&scoped=true"
import script from "./ListRecommend.vue?vue&type=script&lang=js"
export * from "./ListRecommend.vue?vue&type=script&lang=js"
import style0 from "./ListRecommend.vue?vue&type=style&index=0&id=096c4c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c4c6a",
  null
  
)

export default component.exports